<div class="spin-loader">
  @if (isLoading) {
    <mat-icon class="spin-loader__loop">loop</mat-icon>
  }
  @if (!isLoading && isLoaderFinished) {
    <mat-icon class="spin-loader__check">check</mat-icon>
  }
</div>
